"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUniversal = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var can_1 = tslib_1.__importDefault(require("can"));
require("components/image-universal/image-universal");
var React = tslib_1.__importStar(require("react"));
var ReactCanWrapper_1 = require("../../../ReactCanWrapper");
function ImageUniversal(props) {
    var options = new can_1.default.Map({
        image: props.image,
        asBackground: props.asBackground,
    });
    var template = "<image-universal crop=\"fill\" {image}={image} asBackground={asBackground}/>";
    return (React.createElement(ReactCanWrapper_1.ReactCanWrapper, { className: 'c-image-cloudinary', template: template, options: options }));
}
exports.ImageUniversal = ImageUniversal;
